import SVG from 'react-inlinesvg';
import "svg2pdf.js";
import { jsPDF } from "jspdf";
import { QrCode as QrCodeSVG } from "../../../icons"
import { useModal } from "../../../hooks/useModal"
import { Modal } from "../../ui/modal";
import ComponentCard from "../../common/ComponentCard";
import Button from '../../ui/button/Button';
import { useToast } from "../../../context/ToastContext";

import { Menu } from '../../../types/menuTypes';

let ORIGINAL_SIZE = 198
if (import.meta.env.DEV) {
  ORIGINAL_SIZE = 198
}
const PADDING = 6;

const QrCodes = (menu: Menu) => {
  const { qrCode, name } = menu;
  const { isOpen, openModal, closeModal } = useModal();
  const toast = useToast();

  const currentDateTime = () => {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = { 
      day: '2-digit', month: '2-digit', year: 'numeric', 
      hour: '2-digit', minute: '2-digit', hour12: false 
    };

    const formatted = new Intl.DateTimeFormat(undefined, options)
      .format(now)
      .replace(',', '')
      .replace(/\./g, '-')
      .replace(' ', '-');
    return formatted;
  }  

  const exportToPdf = async () => {
    const fullSize = ORIGINAL_SIZE + PADDING * 2;
    const parser = new DOMParser();
    const doc = parser.parseFromString(qrCode.qrSvg, "image/svg+xml");
    const svgElement = doc.documentElement;
    const pdf = new jsPDF('p', 'pt', [fullSize, fullSize]);

    pdf.svg(svgElement, {
      x: PADDING,
      y: PADDING,
      width: ORIGINAL_SIZE, 
      height: ORIGINAL_SIZE
    }).then(() => {
      pdf.save(`${name}-${currentDateTime()}.pdf`);
    });
  };

  const exportSvgToJpg = async () => {
    const canvas = document.createElement('canvas');
    const fullSize = ORIGINAL_SIZE + PADDING * 2;
    canvas.width = fullSize;
    canvas.height = fullSize;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      console.error("Failed to get canvas context");
      toast.error("Failed to export JPEG");
      return;
    }
    const img = new Image();

    const formattedSvg = qrCode.qrSvg.includes('xmlns') 
      ? qrCode.qrSvg 
      : qrCode.qrSvg.replace('<svg', '<svg xmlns="http://www.w3.org"');
      
    const svgBlob = new Blob([formattedSvg], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, fullSize, fullSize);

      ctx.drawImage(img, PADDING, PADDING, ORIGINAL_SIZE, ORIGINAL_SIZE);

      const jpgUrl = canvas.toDataURL('image/jpeg', 0.95);
      const link = document.createElement('a');
      link.href = jpgUrl;
      link.download = `${name}-${currentDateTime()}.jpg`;
      link.click();

      URL.revokeObjectURL(url);
    };

    img.src = url;
  };
  return (
    <div key={qrCode?.id}>
      <button
        onClick={openModal}
        className="min-h-full flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
      >
        <QrCodeSVG width={20} height={20}/>
        QrCode
      </button>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        showCloseButton
        className="max-w-[700px] max-h-[95vh] overflow-x-auto custom-scrollbar">
          <ComponentCard title="QR Code">
            <div className="flex flex-col items-center gap-4">
              <SVG
                src={qrCode.qrSvg} 
                style={{ 
                  padding: PADDING,
                  width: ORIGINAL_SIZE + PADDING * 2,
                  height: ORIGINAL_SIZE + PADDING * 2,
                  backgroundColor: 'white',
                  display: 'inline-flex'
                }} 
              />
              <p className="text-sm text-gray-500 dark:text-gray-400">{qrCode.data}</p>
              <div className="flex justify-evenly w-full">
                <Button
                  size="md"
                  onClick={exportToPdf}
                >
                  Export PDF
                </Button>
                  <Button
                  size="md"
                  onClick={exportSvgToJpg}
                >
                  Export JPEG
                </Button>
              </div>  
            </div>
          </ComponentCard>  
      </Modal>
    </div>
  );
}

export default QrCodes;
